export { default } from './LazyDialogGetPhoneContent';
